import * as R from 'ramda';

export interface FieldError {
  key: string;
  detail: string;
}

export interface StringMap {
  [key: string]: string;
}

const reducer = (acc: StringMap, { key, detail }: FieldError) => {
  const firstCharLower = `${key.slice(0, 1).toLowerCase()}${key.slice(1)}`;
  acc[firstCharLower] = detail;

  return acc;
};

export default R.reduce<FieldError, StringMap>(reducer, {});
